import { useUserData } from '../../../hooks'
import { isStaffUser } from '../../../utils/user'
import { NewsboardPostProfileWidgetAudience } from '../NewsboardPostProfileWidgetAudience'
import { NewsboardPostProfileWidgetCreated } from '../NewsboardPostProfileWidgetCreated'
import { NewsboardPostProfileWidgetServiceRequests } from '../NewsboardPostProfileWidgetServiceRequests'

function NewsboardPostProfileWidgetList() {
  const user = useUserData()

  const isStaff = Boolean(user) && isStaffUser(user)

  return (
    <>
      <NewsboardPostProfileWidgetAudience />
      {isStaff ? <NewsboardPostProfileWidgetServiceRequests /> : null}
      <NewsboardPostProfileWidgetCreated />
    </>
  )
}

export default NewsboardPostProfileWidgetList
